import React from "react";
import ButtonLoader from "../button-loader";
import { Link } from "react-router-dom";
interface IButtonCommon {
  onPressButton: () => void;
  btnLabelText: string;
  navigationLink?: string | undefined;
  wrapperStyles?: React.CSSProperties;
  loading?: boolean;
  disabled?: boolean;
  buttonType?: string;
  extraClassName?: string;
}
const ButtonCommon: React.FC<IButtonCommon> = (props: IButtonCommon) => {
  const {
    onPressButton,
    loading,
    btnLabelText,
    disabled,
    extraClassName,
    wrapperStyles,
    navigationLink,
    buttonType,
  } = props;
  return (
    <div style={{ ...wrapperStyles }}>
      <Link to={navigationLink ? navigationLink : ""}>
        <button
          type={buttonType}
          className={`button-common ${disabled ? "disabled" : ""}`}
          onClick={onPressButton}
          disabled={loading && disabled}
        >
          {!loading ? (
            <span>{btnLabelText}</span>
          ) : (
            <ButtonLoader height={15} width={15} colorProp="white" />
          )}
        </button>
      </Link>
    </div>
  );
};

export default ButtonCommon;
